import React from "react";
import { Link } from "react-router-dom";
import useCookiesCheck from "../../utils/useCookiesCheck";
import { useTranslation } from "react-i18next";

const DynamicThanksMsg = () => {
  useCookiesCheck();
  const { t } = useTranslation();

  return (
    <div className="container">
      <h2>{t("other.thankYou")}</h2>
      <div className="content">{t("other.cancelConfirmMessage")}</div>
      <Link to="/booking-details">OK</Link>
    </div>
  );
};

export default DynamicThanksMsg;
